export default function postCouponReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'CREATE_COUPON_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'CREATE_COUPON_ERROR':
      return {...state, ...{error: action.error}};

    case 'CREATE_COUPON_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}